module.exports = __webpack_public_path__ + "img/Grupo 26855.8b4e571a.png";